module.exports = __webpack_public_path__ + "img/White-tail-Deer.879eb641.jpg";